import { reportClient } from '../../api/clients';
import getIssuesScore from '../../executive-summary/services/get-issues-score.service';
import exportAppSbomToCsv from './export-app-sbom-to-csv/export-app-sbom-to-csv';
import exportSbomOrgToCsv from './export-sbom-to-csv/export-sbom-to-csv';
import getApplicationsFilters from './get-applications-filters/get-applications-filters';
import getApplicationsIds from './get-applications-ids/get-applications-ids-service';
import getApplicationsSbom from './get-applications-sbom/get-applications-sbom-service';
import getApplications from './get-applications-service/get-applications-service';
import getOrgSbomCsv from './get-org-sbom-csv/get-org-sbom-csv';
import getOrganizationSbom from './get-organization-sbom/get-organization-sbom-service';
import getSingleApplication from './get-single-application/get-single-application-service';
import setPriority from './set-business-priority/set-business-priority-service';
import setRelevance from './set-relevance-service/set-relevance-service';

const applicationsService = {
  getApplications: getApplications(reportClient),
  getApplicationsIds: getApplicationsIds(reportClient),
  getApplicationsFilters: getApplicationsFilters(reportClient),
  getSingleApplication: getSingleApplication(reportClient),
  getApplicationsSbom: getApplicationsSbom(reportClient),
  getOrganizationSbom: getOrganizationSbom(reportClient),
  setRelevance: setRelevance(reportClient),
  setPriority: setPriority(reportClient),
  getIssuesScore: getIssuesScore(reportClient),
  exportSbomToCsv: exportSbomOrgToCsv(reportClient),
  exportAppSbomToCsv: exportAppSbomToCsv(reportClient),
  getOrgSbomCsv: getOrgSbomCsv(reportClient),
};
export default applicationsService;
